import { Loading, PermissionDenied } from '@/components';
import type { FC, PropsWithChildren } from 'react';

import { useLocalTagPermission } from '../_hooks/permission';
import type { ResourceGuardProps } from '../_types/authentication';

export const LocalTagResourceGuard: FC<
  PropsWithChildren<ResourceGuardProps>
> = ({ onlyEdit, showDenied, children }) => {
  const permission = useLocalTagPermission(onlyEdit);

  if (permission.isPending) {
    return <Loading />;
  }

  return permission.data ? (
    <>{children}</>
  ) : showDenied ? (
    <PermissionDenied />
  ) : null;
};
